/* eslint-disable import/no-anonymous-default-export */
export default {
  API_ENDPOINT: "https://vast-harbor-02071.herokuapp.com/api",
  TOKEN_KEY: "beware-oblivion-is-at-hand",
};
